const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- avatar-picker ---
let __fez_component_0;
{
const SIDE = 256

// The middle square of an image file, 256px, as base64 of WebP (else PNG).
async function squareOf(file) {
  const bitmap = await createImageBitmap(file)
  const side = Math.min(bitmap.width, bitmap.height)
  const canvas = document.createElement('canvas')
  canvas.width = SIDE
  canvas.height = SIDE
  const context = canvas.getContext('2d')
  context.imageSmoothingQuality = 'high'
  context.drawImage(bitmap, (bitmap.width - side) / 2, (bitmap.height - side) / 2, side, side, 0, 0, SIDE, SIDE)
  bitmap.close()
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/webp', 0.9))
  if (!blob) throw new Error('This image could not be read.')
  const bytes = new Uint8Array(await blob.arrayBuffer())
  let binary = ''
  for (let index = 0; index < bytes.length; index += 0x8000) binary += String.fromCharCode(...bytes.subarray(index, index + 0x8000))
  return btoa(binary)
}
__fez_component_0 = class {
  PROPS = {
    name: String,
  }

  init() {
    this.state.busy = ''
    this.state.error = ''
  }

  pick() {
    this.find('.ap-file').click()
  }

  async upload(event) {
    const file = event.target.files?.[0]
    event.target.value = ''
    if (!file) return
    this.state.busy = 'upload'
    this.state.error = ''
    try {
      if (!file.type.startsWith('image/')) throw new Error('Pick an image: PNG, JPEG, WebP or GIF.')
      const data = await squareOf(file)
      this.globalState.me = await window.App.api('user/avatar', { data }, { silent: true })
    } catch (error) {
      this.state.error = error.details?.data || error.message
    } finally {
      this.state.busy = ''
    }
  }

  async remove() {
    this.state.busy = 'remove'
    this.state.error = ''
    try {
      this.globalState.me = await window.App.api('user/avatar_remove', {}, { silent: true })
    } catch (error) {
      this.state.error = error.message
    } finally {
      this.state.busy = ''
    }
  }

  beforeRender() {
    const me = this.globalState.me || {}
    this.state.user = { ...me, name: this.props.name || me.name || '' }
    this.state.manual = Boolean(me.manual_avatar)
    this.state.note = me.avatar ? (this.state.manual ? 'Your picture.' : 'Your picture from AuthCog.') : 'No picture yet: your initials show.'
  }

  CSS = `:fez {
display:block;.ap{display:flex;align-items:center;gap:var(--space-4)}.ap-side{display:grid;gap:var(--space-2);min-width:0}.ap-note{margin:0;color:var(--color-text-muted);font-size:var(--text-sm)}.ap-actions{display:flex;flex-wrap:wrap;gap:var(--space-2)}.ap-error{margin:0;color:var(--color-danger);font-size:var(--text-sm)}.ap-file{display:none}
}`

  HTML = `<div class="ap">
<ui-avatar :user="state.user" size="xl"></ui-avatar>
<div class="ap-side">
<p class="ap-note">{state.note}</p>
<div class="ap-actions">
<ui-button size="sm" icon="upload-simple" label={state.manual ? 'Upload another' : 'Upload a picture'} :loading="state.busy === 'upload'" onclick="fez.pick()"></ui-button>
{#if state.manual}
<ui-button size="sm" variant="ghost" icon="trash" label="Remove" :loading="state.busy === 'remove'" onclick="fez.remove()"></ui-button>
{/if}
</div>
{#if state.error}<p class="ap-error" role="alert">{state.error}</p>{/if}
</div>
<input class="ap-file" type="file" accept="image/png,image/jpeg,image/webp,image/gif" onchange="fez.upload(event)">
</div>`
};
}

Fez('avatar-picker', __fez_component_0);

export default __fez_component_0;
